<template>
  <div class="email" v-if="show">
    <div style="height: 70px; padding: 0 30px" class="uc ub-ac">
      <div>
        <img :src="logoimg" style="width: 15rem" />
      </div>
      <div class="uc ub-ac title-css">“清廉天能”举报平台</div>
    </div>
    <div class="banner">
      <div style="height: 20vh">
        <el-carousel style="height: 100%" height="100%" :autoplay="false">
          <el-carousel-item
            v-for="item in 1"
            :key="item"
            style="height: 100%; width: 100%"
          >
            <div style="position: relative; width: 100%; height: 100%; top: 0">
              <el-image
                style="width: 100%; height: 100%"
                :src="banner"
                fit="cover"
              ></el-image>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div style="width: 100%; background: #fafafa">
      <div class="model-css" style="">
        <div class="title-h2">“清廉天能”举报平台</div>

        <div class="form-el2-css">
          <el-divider content-position="left"
            >天能建立以下廉洁举报受理渠道
          </el-divider>
          <div style="background: #fff">
            <el-row class="header-tip-css" style="">
              <el-col :xs="24" :sm="24">
                <div class="header-tip-col uc ub-ac">
                  <div class="header-tip-tit-css">电&ensp;话 ：</div>
                  <span class="header-tip-text-css">
                    <a class="-icon-text" href="tel:13857823563">13857823563</a>
                    /
                    <a class="-icon-text" href="tel:13588424906">13588424906</a>
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24">
                <div class="header-tip-col uc ub-ac">
                  <div class="header-tip-tit-css">邮&ensp;箱 ：</div>
                  <span class="header-tip-text-css">
                    <a class="-icon-text" href="mailto:tiannengjubao@163.com"
                      >tiannengjubao@163.com</a
                    >
                  </span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24">
                <div class="header-tip-col uc ub-ac">
                  <div class="header-tip-tit-css">Q&ensp;&ensp;Q ：</div>
                  <span class="header-tip-text-css">2179414802</span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24">
                <div class="header-tip-col uc">
                  <div class="header-tip-tit-css">地&ensp;址 ：</div>
                  <div class="header-tip-text-css uc ub-f1">
                    浙江省长兴县包桥路18号天能集团研发楼317审计监察中心
                  </div>
                  <!-- <div v-if="!device" class="header-tip-text-css">
                    <div>浙江省长兴县包桥路18号天能集团研发楼317审计</div>
                    <div>监察中心</div>
                  </div> -->
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="form-css" style="padding-top: 1rem">
          <el-form
            ref="elForm"
            :model="form"
            :rules="formrule"
            label-width="120px"
            :label-position="device ? 'right' : 'top'"
          >
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12">
                <div class="form-el-css">
                  <el-divider content-position="left"
                    >举&ensp;报&ensp;信&ensp;息
                  </el-divider>
                  <el-form-item label="举报主题" prop="reportingTopic">
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="form.reportingTopic"
                    ></el-input>
                  </el-form-item>
                  <el-row>
                    <el-col :xs="24" :sm="14">
                      <el-form-item label="被举报人员姓名" prop="reportingName">
                        <el-input v-model="form.reportingName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                      <el-form-item
                        label="职务"
                        :label-width="device ? '60px' : '110px'"
                        prop="reportingDuties"
                      >
                        <el-input v-model="form.reportingDuties"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="被举报公司名称" prop="reportingCompany">
                    <el-input v-model="form.reportingCompany"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xs="24" :sm="12">
                <div class="form-el-css">
                  <el-divider content-position="left">举报人信息</el-divider>
                  <div class="uc ub-f1 ub-end">
                    <div class="tip-css" style="color: #002d72">
                      鼓励实名举报，建议您至少留下一种联系方式，用于向您了解详细情况及补充证据之用，我们会严格保密。
                    </div>
                  </div>
                  <el-form-item label="姓名" prop="presenterName">
                    <el-input v-model="form.presenterName"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号码" prop="presenterPhone">
                    <el-input v-model="form.presenterPhone"></el-input>
                  </el-form-item>
                  <el-form-item label="电子邮箱" prop="reportingEmail">
                    <el-input v-model="form.reportingEmail"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24">
                <div class="form-el2-css">
                  <el-form-item label="举报内容" prop="reportingContent">
                    <el-input
                      type="textarea"
                      :rows="5"
                      v-model="form.reportingContent"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>

          <el-form :model="form" :label-width="device ? '125px' : ''">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" style="min-width: 300px">
                <div class="form-el2-css">
                  <el-form-item label="附件" prop="reportingFile">
                    <el-upload
                      :action="serverHost + '/api/upload'"
                      :on-success="handleSucess"
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      multiple
                      :file-list="fileList"
                    >
                      <div class="uc">
                        <el-button
                          style="width: 100%; height: 40px; background: #006fc2"
                          type="primary"
                          icon="el-icon-upload2"
                          >上传附件</el-button
                        >
                      </div>
                    </el-upload>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xs="24" :sm="16">
                <div style="line-height: 20px; font-size: 12px">
                  可以上传多个附件，附件最大为20M，可上传格式为gif、 jpg、
                  jpeg、 png、 mp3、 aac、 wav、 avi、 mp4、mov、 zip、 rar、
                  doc、 docx、 ppt、 pptx、 xls、 xlsx、 wps、 txt、 pdf。
                </div>
              </el-col>
            </el-row>
          </el-form>

          <div
            class="ub ub-ac ub-pc"
            style="width: 50%; margin: auto; padding: 3rem 0"
          >
            <div style="font-size: 13px; padding-bottom: 5px">
              带<span style="color: red">*</span>为必填项
            </div>
            <el-button
              :loading="loading"
              @click="send"
              type="primary"
              style="width: 100%; border-radius: 30px; background: #006fc2"
              >{{ loading ? "数据提交中" : "确认提交" }}</el-button
            >
          </div>
        </div>
      </div>
      <div style="background: #d0cfcf; height: 5rem" class="uc ub-ac ub-pc">
        <div
          style="
            font-family: '微软雅黑', 宋体, Arial, sans-serif;
            font-size: 12px;
            line-height: 28px;
            color: #ffffff;
          "
          align="center"
        >
          Copyright © 天能控股集团 All Rights Reserved
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      top="30vh"
      :visible.sync="dialogVisible"
      :width="device ? '300px' : '80%'"
      center
    >
      <div class="uc ub-pc ub-ac">
        <i
          :class="[
            status ? 'el-icon-success' : 'el-icon-warning',
            status ? 'el-icon-size-success' : 'el-icon-size-error',
            'el-icon-size',
          ]"
          style=""
        ></i>
        <span class="tip-title">{{ errorMes }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :type="status ? 'success' : 'info'"
          size="small"
          style="width: 100%"
          @click="dialogVisible = false"
          >好的,我知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import logoimg from "@/assets/image/logo2.png";
import bannerpc from "@/assets/image/banner-pc.jpg";
import bannerwx from "@/assets/image/banner-wx.jpg";
const phoneReg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
  phoneText = "请输入正确手机号格式",
  emailReg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/,
  emailText = "请输入正确邮件格式",
  reg =
    /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]|[\~|\@|\#|\$|\^|\￥|\&|\*|\—|\+|\{|\}|\'|\"|\[|\]|\《|\》|\、|\！|\？|\!|\?]/, // /\~|\@|\#|\$|\^|\￥|\&|\*|\—|\+|\{|\}|\<|\>|\'/g,
  errorReg = "请勿输入特殊字符";
export default {
  name: "email",
  data() {
    return {
      show: false,
      banner: bannerpc,
      logoimg: logoimg,
      device: true,
      form: {
        reportingTopic: "",
        reportingName: "",
        reportingDuties: "",
        reportingCompany: "",
        reportingContent: "",
        presenterName: "",
        presenterPhone: "",
        reportingEmail: "",
        reportingFile: [],
      },
      formrule: {
        reportingTopic: [
          { required: true, message: "请输入举报主题", trigger: "blur" },
          { pattern: reg, message: errorReg, trigger: "blur" },
        ],
        reportingName: [
          { required: true, message: "请输入被举报人员姓名", trigger: "blur" },
          { pattern: reg, message: errorReg, trigger: "blur" },
        ],
        reportingCompany: [
          { required: true, message: "请输入被举报公司名称", trigger: "blur" },
          { pattern: reg, message: errorReg, trigger: "blur" },
        ],
        reportingContent: [
          { required: true, message: "请输入举报内容", trigger: "blur" },
          { pattern: reg, message: errorReg, trigger: "blur" },
        ],
        presenterPhone: [
          { pattern: phoneReg, message: phoneText, trigger: "blur" },
        ],
        reportingEmail: [
          { pattern: emailReg, message: emailText, trigger: "blur" },
        ],
      },
      fileList: [],
      dialogVisible: false,
      errorMes: "",
      status: false,
      loading: false,
      serverHost: "http://jubao.cn-tn.com",
    };
  },
  created() {
    if (window.screen.width < window.screen.height) {
      this.device = false;
      this.banner = bannerwx;
    } else {
      this.device = true;
      this.banner = bannerpc;
    }
    setTimeout(() => {
      this.show = true;
    }, 100);
  },
  methods: {
    handleRemove() {},
    handleSucess(res, file) {
      if (res.iRet == 1) {
        this.$message.success(res.info);
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    send() {
      this.fileList.map((f) => {
        this.form.reportingFile.push({
          path: f.response.path,
        });
      });
      this.$refs.elForm.validate((valid, p) => {
        if (valid) {
          this.loading = true;
          const service = axios.create({
            timeout: 10000,
          });
          service
            .post(this.serverHost + "/api/email", this.form)
            .then((res) => {
              console.log(res);
              if (res.data.iRet == 1) {
                this.loading = false;
                this.fileList = [];
                this.form = {
                  reportingTopic: "",
                  reportingName: "",
                  reportingDuties: "",
                  reportingCompany: "",
                  reportingContent: "",
                  presenterName: "",
                  presenterPhone: "",
                  reportingEmail: "",
                  reportingFile: [],
                };
                this.status = true;
                this.errorMes = "举报提交成功";
                this.dialogVisible = true;
              } else {
                this.loading = false;
                this.status = false;
                this.errorMes = "数据提交失败";
                this.dialogVisible = true;
              }
            })
            .catch((r) => {
              this.loading = false;
              this.status = false;
              this.errorMes = "数据提交失败";
              this.dialogVisible = true;
            });
        } else {
          this.status = false;
          for (let key in p) {
            this.errorMes = p[key][0]["message"];
            this.dialogVisible = true;
            return false;
          }
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.email {
  .el-message {
    top: 50vh !important;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .title-css {
    padding: 0 20px;
    font-size: 1.8rem;
    line-height: 100%;
    letter-spacing: 3px;
    font-weight: 700;
    color: #006fc2;
  }

  .title-h2:before {
    content: "";
    width: 9rem;
    border-bottom: 0.4rem solid #002d72;
    display: block;
    position: absolute;
    top: 0;
  }

  .title-h2 {
    font-size: 3.6rem;
    // color: #c1a367;
    color: #006fc2;
    font-weight: 400;
    padding-top: 1.5rem;
    position: relative;
  }
  .model-css {
    padding-top: 5rem;
  }

  .el-divider {
    margin-bottom: 3.5rem;
  }
  /deep/ .el-upload {
    width: calc(100% - 60px);
  }
  .el-dialog {
    .el-dialog__header {
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      padding: 0px 20px 0 20px;
    }
  }
  .el-icon-size-success {
    color: #67c23a;
  }
  .el-icon-size-error {
    color: red;
  }
  /*定义竖屏 css*/
  @media screen and (orientation: portrait) {
    .model-css {
      width: 90%;
      margin: auto;
      .form-el-css {
        width: 100%;
        .el-form-item {
          margin-bottom: 1.5rem;
          /deep/ .el-form-item__label {
            line-height: 3rem !important;
          }
        }
      }
      .tip-css {
        width: 100%;
        padding-bottom: 1rem;
        font-size: 14px;
        line-height: 24px;
      }
      .form-el2-css {
        width: 100%;
        margin: auto;
      }
      .header-tip-css {
        padding: 1.5rem 0;
        font-size: 1.5rem;
        width: 92%;
        margin: auto;
        .header-tip-col {
          padding-bottom: 0.6rem;
          .header-tip-tit-css {
            color: rgba(23, 70, 131, 0.8);
            font-weight: 700;
            width: 56px;
          }
          .header-tip-text-css {
            color: rgba(23, 70, 131, 0.8);
          }
        }
      }
    }
    .el-divider__text {
      font-size: 2.2rem !important;
      color: #174683 !important;
      background: #fafafa !important;
      padding: 5px 20px !important;
    }
    .el-icon-size {
      font-size: 2.5rem;
      padding-right: 8px;
      padding-bottom: 8px;
    }
    .tip-title {
      font-size: 2rem;
      padding-bottom: 8px;
      // color: red;
    }
  }

  /*定义横屏 css*/
  @media screen and (orientation: landscape) {
    .el-icon-size {
      font-size: 2rem;
      padding-right: 8px;
      padding-bottom: 8px;
    }
    .tip-title {
      font-size: 1.2rem;
      padding-bottom: 8px;
    }
    .model-css {
      width: 55%;
      min-width: 940px;
      margin: auto;
      .tip-css {
        width: 91%;
        padding-bottom: 1rem;
        font-size: 14px;
        line-height: 24px;
      }
      .header-tip-css {
        padding: 1.5rem 0;
        font-size: 1.2rem;
        width: 92%;
        margin: auto;
        .header-tip-col {
          padding-bottom: 0.3rem;
          .header-tip-tit-css {
            color: rgba(23, 70, 131, 0.8);
            font-weight: 700;
            width: 60px;
          }
          .header-tip-text-css {
            color: rgba(23, 70, 131, 0.8);
          }
        }
      }
    }
    .el-divider__text {
      font-size: 1.8rem !important;
      color: #174683 !important;
      background: #fafafa !important;
      padding: 5px 20px !important;
    }
    .form-el-css {
      width: 92%;
      margin: auto;
    }
    .form-el2-css {
      width: 96%;
      margin: auto;
    }
  }

  .ub {
    display: flex;
    flex-direction: column;
  }
  .ub-f1 {
    flex: 1;
  }
  .uc {
    display: flex;
    flex-direction: row;
  }
  .ub-pc {
    justify-content: center;
  }

  .ub-end {
    justify-content: flex-end;
  }

  .uc-end {
    align-items: flex-end;
  }
  .ub-ac {
    /* align-content: center; */
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report.vue